module.exports = __webpack_public_path__ + "img/level_logo3.7359e15d.png";